<template>
  <div>

    <b-navbar toggleable="lg" small type="dark" variant="dark">
      <b-navbar-brand @click="navigateTo('/dashboard')"><img src="@/assets/img/logo_white.png"
          style="max-height: 5vh;" /></b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item @click="navigateTo('/sucursales')">Sucursales</b-nav-item>
          <b-nav-item-dropdown text="Catálogos">
            <b-dropdown-group header="Productos vendibles">
              <b-dropdown-item @click="navigateTo('/groups')"> Grupos</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/products')">Productos</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/personalizations')">Personalizadores</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/product-extra-groups')">Grupos de Extras</b-dropdown-item>
            </b-dropdown-group>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-group header="Generales">
              <b-dropdown-item v-if="this.hasPermission('rrn:central:floors:list')" @click="navigateTo('/floors')"> Mesas</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/preparationareas')"> Áreas de Preparación</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/discounts')">Descuentos</b-dropdown-item>
              <b-dropdown-item v-if="this.hasPermission('rrn:central:loyalty:getProgram')" @click="navigateTo('/loyaltyprograms')">Programas de Lealtad</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/paymentmethods')">Formas de pago</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/waiters')"> Meseros</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/paydesk/movements')">Movimientos de Caja</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/areas')">Areas</b-dropdown-item>

            </b-dropdown-group>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-group header="Insumos y almacén">
              <b-dropdown-item @click="navigateTo('/supplycategories')">Categorias de insumos</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/supplies')">Insumos</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/supply/lists')">Listas de Insumos</b-dropdown-item>
              <b-dropdown-item @click="navigateTo('/providers')">Proveedores</b-dropdown-item>

            </b-dropdown-group>
          </b-nav-item-dropdown>
          
          <b-nav-item-dropdown v-if="this.hasPermission('rrn:central:platforms:uber') || this.hasPermission('rrn:central:platforms:rappi')" text="Plataformas">
            <b-dropdown-header v-if="this.hasPermission('rrn:central:platforms:uber')">Uber</b-dropdown-header>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:platforms:uber')" @click="navigateTo('/uber/stores')">Sucursales/Stores</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:platforms:uber')" @click="navigateTo('/uber')">Creador de Menus</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:platforms:uber')" @click="navigateTo('/uber/menu/viewer')">Visor de Menus</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:platforms:uber')" @click="navigateTo('/uber/menu/copy')">Copia de Menus</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:platforms:uber')" @click="navigateTo('/uber/onboarding')">Onboarding (Alta de tiendas)</b-dropdown-item>

            <b-dropdown-header v-if="this.hasPermission('rrn:central:platforms:rappi')">Rappi</b-dropdown-header>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:platforms:rappi')" @click="navigateTo('/rappi/stores')">Sucursales/Stores</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:platforms:rappi')" @click="navigateTo('/rappi/menu')">Creador de Menus</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:platforms:rappi')" @click="navigateTo('/rappi/onboarding')">Onboarding (Alta de tiendas)</b-dropdown-item>
            <b-dropdown-header>Plataformas</b-dropdown-header>
            <b-dropdown-item :to="{ name: 'platform-overview' }" exact>Dashboard</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'platform-builder' }">Constructor de Menús</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'platform-orders' }">Órdenes</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'platform-menus' }">Menus</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'platform-categories' }">Categorías</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'platform-items' }">Artículos</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'platform-modifiers' }">Modificadores</b-dropdown-item>
          
          
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Reportes">
            <b-dropdown-item @click="navigateTo('/inventory/report')">Cambio de Inventario</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/turnos')">Turnos</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/dashboard')">Resumen General</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:reports:dailyReport')" @click="navigateTo('/report/daily')">Venta Diaria</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:reports:dailyByArea')" @click="navigateTo('/report/daily/area')">Venta Diaria Por Área</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:reports:productPopularity')" @click="navigateTo('/report/popularidad')">Venta Por
              Articulo/Popularidad</b-dropdown-item>
            <b-dropdown-item v-if="this.hasPermission('rrn:central:reports:waiterPerformance')" @click="navigateTo('/report/waiter/performance')">Desempeño de Meseros</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/report/recipe-consumption')">Consumo de Recetas</b-dropdown-item>
            <b-dropdown-item  @click="navigateTo('/report/almacen/general')">Reporte Diario Almacén General</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/ticket/query')">Buscar Cuentas</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/report/date')">Mas Reportes</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Inventarios">
            <b-dropdown-item @click="navigateTo('/inventory/report')">Cambio de Inventario</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/inventario/ajustes')">Conteo Físico</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/compras')">Compras</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/inventory/suggested-po')">Orden de Compra Sugerida</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/movimientos')">Movimientos de Inventario</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/stock-locations')">Ubicaciones de Inventario</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/cost-management')">Gestión de Costos</b-dropdown-item>

            <b-dropdown-header>Analisis</b-dropdown-header>

            <b-dropdown-item v-if="this.hasPermission('rrn:central:stock:get')" @click="navigateTo('/existencias')">Existencias</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/stock/analyze')">Analisis de Inventario</b-dropdown-item>


            <b-dropdown-header>Producción</b-dropdown-header>
            <b-dropdown-item @click="navigateTo('/boms')">Recetas de Producción</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/manufacturingorders')">Ordenes de Produccion</b-dropdown-item>


            <b-dropdown-header>Roadmap</b-dropdown-header>
            <b-dropdown-item
              href="https://rigada.notion.site/11f6495b9b1f80a2bcefee07162023f7?v=121ce6467efb401c84dc6f92dd4e3c94">Roadmap
              Inventarios</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Tickets">
            <b-dropdown-item @click="navigateTo('/ticket/query')">Buscar</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Usuarios" v-if="this.hasPermission('rrn:central:users:getUser')">
            <b-dropdown-item @click="navigateTo('/userGroups')">Grupos</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/signup')">Usuarios</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Facturacion">
            <b-dropdown-item @click="navigateTo('/facturas')">Mis Facturas</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/factura')">Nueva Factura</b-dropdown-item>
            <b-dropdown-item @click="navigateTo('/facturacion/clientes')">Clientes</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-if="this.hasPermission('rrn:central:loyalty:getProgram')" @click="navigateTo('/loyaltyprograms')">Lealtad</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="navigateTo('/selecttenant?override=true')">Espacio: {{ tenant }}</b-nav-item>
          <b-nav-item-dropdown text="Mi usuario" right>
            <b-dropdown-item-button @click="logout">Salir</b-dropdown-item-button>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "Nav",
  computed: {
    tenant() {
      return this.$store.getters["server/tenant"];
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("user-token");
      localStorage.removeItem("user-token-time");
      axios.defaults.headers.common["Authorization"] = "Bearer ";
      this.$router.push("/").catch();
    },
    navigateTo(path) {
      this.$router.push(path);
    }
  }
}
</script>